import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hydratedAction } from './actions';

export const useHydrated = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(hydratedAction);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
